<template>
  <!-- 
  1.화면ID    : MCF_PR_001
  2.화면명    : 화면 권한 관리 
  3.작성자    : 윤태영 차장
  추가자    : 
  4.화면설명  : 화면권한 관리화면이다. 
* A Copyright Notice : Copyright 2024 SNC.CO All rights reserved

  관련 테이블 : eb_auth_grp_tb 
               eb_user_auth_tb
               eb_auth_grp_menu
               sy_user_tb

-->

  <div class="content-wrap">
    <div class="row gx-3">
      <div class="col-md-4 col-sm-12">
        <div class="border h-100">
          <div class="code-subtitle">권한 그룹</div>
          <div class="py-3 px-3 dotline-b">
            <!-- <input type="text" class="form-control form-control-sm" id="" value="권한조회"> -->
            <ElInput 
            classNm="form-control form-control-sm" 
            placeholder="권한명 입력 후 엔터를 누르세요"
            :value="state.auth_grp_nm"
            @update:modelValue="r=>state.auth_grp_nm=r"
            @inputKeyupEnter="fetchPrivilegeUsrList()"/>

            <div class="my-2">
              <ElButton type="codeRegist" @buttonClick="clickRowCRUD('add')"><span class="ic-code-plus"></span> 등록</ElButton>
              <ElButton type="codeRegist" @buttonClick="clickRowCRUD('edit')"><span class="ic-code-edit"></span> 수정</ElButton>
              <ElButton type="codeRegist" @buttonClick="clickRowCRUD('delete')"><span class="ic-code-del"></span> 삭제</ElButton>
            </div>
          </div>

          <div class="p-3 d-flex flex-column">
            <div v-for="(item,index) of authGrpList" class="btn btn-sm btn-code2 mb-1" :key=index
              @click="getDataSubList(item,index)">
              <!--수정일때-->
              <ElInput 
              v-if="item.editable"
              ref="editRef"
              v-model="item.auth_grp_nm"
              :focusYn="true"
              @inputKeyupEnter="r=>r.target.blur()"
              @inputBlur="editComplete(item)"
              />
              <!--읽기모드-->
              <span class="ic-code-man"></span>
              <span v-if="item.auth_grp_nm && !item.editable" :class="[index === clickAuthData.index ? 'text-blue' : '']">{{
                item.auth_grp_nm }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-8 col-sm-12">


        <div class="border h-100">
          <div class="p-3">

            <div class="sch-sm-group">
              <div class="sch-sm-item">
                <div class="row">
                  <ElLabel name="그룹 상세" classNm="col-auto col-form-label">
                    <template #end="{id}">
                      <div class="col-sm-3">
                        <ElInput :id="id" v-model="clickAuthData.auth_grp_id"/>
                      </div>
                    </template>
                  </ElLabel>
                </div>
              </div>

            </div>
            <div class="tree-table-list table-line mt-3">
              <TreeTable :value="state.gridRowData" 
                v-model:selectionKeys="state.selectRows" 
                selectionMode="checkbox">
                <template #empty>
                    <div class="">데이터가 존재하지 않습니다.</div>
                </template>
                <Column v-for="item of state.gridColumn" :field="item.field" :header="item.headerName" :key="item.field"
                  :expander="item.expander">
                  <template #body="authProps">
                    <span>
                      {{ authProps.node.data[authProps.column.key] }}
                    </span>
                  </template>
                </Column>
              </TreeTable>
            </div>

            <div class="text-end py-3">
              <ElButton type="primary" @buttonClick="saveRow()">저장</ElButton>
            </div>

          </div>
        </div>
      </div>
    </div>
   
  </div>

</template>

<script setup>

import { reactive, ref, onBeforeMount, nextTick, computed } from 'vue'
import TreeTable from "primevue/treetable";
import Column from 'primevue/column';
import { useUserStore } from '@/store/user'
const userStore = useUserStore()

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { getAuthGrpList, getAuthGrpMenuList,getAuthGrpInsert,getAuthGrpUpdate, getAuthGrpDelete, userAuthGrpMenuEdit } from '@/api/userInfo';

const props = defineProps(['gridColumn', 'dataList', 'editable', 'rootVal']);
const emits = defineEmits(['editCol', 'editComplete'])

let editRef = ref()
let parentKey;
let key;

onBeforeMount(async () => {
  await fetchPrivilegeUsrList()
})

const state = reactive({
  selectedKey: [],
  gridColumn: [
    {
      headerName: '메뉴',
      field: "menu_nm",
      expander: true,
    },
    // { headerName: '메뉴ID' , field: "menu_id" },
    // { headerName: '조회권한' , field: "auth_chk" }
  ],
  gridRowData: [],
  selectedRow: [],
  privilegeParams: {
    user_id: '',
    dept_cd: [],
    page_count: 1,
    unit_count: 100000,
  },

  test: [],
  test1: [],
  test2: [],
  auth_grp_id: '',
  dataList: [],

  //    menuIdList: [],
  //    maxMenuId: "",
  selectRows: [],
  originList: [],
  PrivilegeUsrSubList: [],

  privilegeResponse: {
    menu_nm: [],
  },
  clickItem: {},
  auth_grp_nm: '',
  click_grp_id: ''
})

const authGrpList = ref([])
const clickAuthData = ref({})

//화면메뉴 리스트 조회
const fetchPrivilegeUsrList = async () => {
  let param = {
    auth_grp_nm: state.auth_grp_nm
  }
  try {
    setIsLoading(true)
    const res = await getAuthGrpList(param)
    authGrpList.value = [...res.rtn];
  } catch (err) {
    console.error(err)
    alert('권한화면을 불러오는데 실패했습니다.');
  } finally {
    setIsLoading(false)
  }
}

const allCheck = computed({
  get() {
    return state.gridRowData.length === state.selectRows.length;
  },
  set(newValue) {
    state.selectRows = newValue ? state.originList.map((item) => { return item.menu_id }) : [];
  }
})

// 권한상세 조회건  
const getDataSubList = async (r,index) => {
  state.selectRows = []
  clickAuthData.value = r
  clickAuthData.value.index = index
  let params = {
    auth_grp_id: r.auth_grp_id,
  };
  try {
    setIsLoading(true)
    const res = await getAuthGrpMenuList(params)

    state.selectRows = {};

    state.originList = [...res.rtn]

    let rootList = [];

    for (let item of state.originList) {
      if (item.upper_menu_id == '') {
        let row = {
          key: item.menu_id,
          data: item,
        };
        rootList.push(row);
      }
    }

    rearrange(rootList);
    setSelectBox(rootList)
    state.gridRowData = [...rootList];
    state.auth_grp_nm = clickAuthData.value.auth_grp_nm
  } catch (err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }
};

const rearrange = (rootList) => {
  for (let item of rootList) {
    let childTree = [];
    state.originList.filter((i) => {
      if (i.upper_menu_id == item.key) {
        let row = {
          key: i.menu_id,
          data: i,
        };
        childTree.push(row);
      }
    });
    if (childTree?.length > 0) {
      item.children = childTree;
      rearrange(childTree);
    }
  }
};

const clickRowCRUD = async (status) => {
  if(status !== 'add' && !clickAuthData.value.user_auth_seq){
    alert('권한그룹을 선택해주세요')
    return
  }
  try{
    setIsLoading(true)

    switch(status){
      case 'add' :
        let params = {auth_grp_id:'',auth_grp_nm:'new group',ss_user_id : userStore.user.employeeId}
        await getAuthGrpInsert(params)
        fetchPrivilegeUsrList()
      break
      case 'edit' :
        authGrpList.value.forEach((item,index)=>{
          if(item.user_auth_seq === clickAuthData.value.user_auth_seq ){
            authGrpList.value[index]['editable'] = true
          }
        })
        await nextTick()
      break
      case 'delete' :
        deleteRow()
      break
    }

  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }


}


//삭제 함수
const deleteRow = async () => {
  if (clickAuthData.value.user_auth_seq) {
    if (confirm("삭제 하시겠습니까?") == true) {
      try {
        setIsLoading(true)
        let params = {
          user_auth_seq: clickAuthData.value.user_auth_seq,
        }
        const res = await getAuthGrpDelete(params)
        clickAuthData.value = {}
        state.gridRowData = []
      } catch (err) {
        console.log('error', err)
        alert('권한그룹 삭제처리 에러 발생')
      } finally {
        setIsLoading(false)
        fetchPrivilegeUsrList()
      }
    } // The end of if statement block    
  } else {
    alert('권한그룹을 선택하여 주세요');
  }
};


//수정이 끝났을경우
const editComplete = async (item) => {
  try {
    setIsLoading(true)
    item.editable = false
    const res = await getAuthGrpUpdate(item)
    await fetchPrivilegeUsrList()
  } catch (err) {
    console.error(err)
  }finally{
    setIsLoading(false)
  }
}


//등록완료 함수
const saveRow = async () => {
  try {
    setIsLoading(true)
    let dataList = Object.keys(state.selectRows).map((item)=>{
      return {mnu_id : item}
    })

    let params = {
      auth_grp_id : clickAuthData.value.auth_grp_id,
      userAuthMnuListVO: dataList,
    }

    if (confirm("변경 하시겠습니까?") == true) {
        await getAuthGrpUpdate(clickAuthData.value)
        const res = await userAuthGrpMenuEdit(params)
        if(res.code === '0000'){
          alert('수정 완료했습니다.');
        }else{
          alert('수정 실패했습니다.');
        }
        await fetchPrivilegeUsrList();
      
    }  

  } catch (err) {
    console.error(err)
    alert('권한그룹 변경 에러 발생 ')
  } finally {
    setIsLoading(false)
  }
}

function setSelectBox(menuList=[]){
  menuList.forEach((menu)=>{
    if(menu.children){
      let cnt = 0
      menu.children.forEach((cMenu)=>{
        if(checkAccessibility(cMenu.key)){
          cnt += 1
          state.selectRows[menu.key] = {partialChecked: true}
          if(!cMenu.children) state.selectRows[cMenu.key] = {checked: true}
        }
      })

      if(cnt > 0) {
        if(cnt === menu.children.length){
          state.selectRows[menu.key] = {checked: true}
        }else{
          state.selectRows[menu.key] = {partialChecked: true}
        }
      }
      setSelectBox(menu.children)
    }
  })
}

function checkAccessibility(menu_id){
  let obj = state.originList.find((item)=>item.menu_id === menu_id)
  if(obj?.mnu_auth_seq) return true
}
</script>

<style scoped>
.table-list table td {
  border-bottom:solid 1px rgb(204, 214, 224, 0.4);
  padding:0.5rem;
  text-align: left !important; 
}
</style>